
<section class="content">
  <router-view></router-view>
</section>
